import { createSlice } from "@reduxjs/toolkit";
import {
  showOvertimeRegistration,
  showOvertimeSummary,
  showOvertimeRegistrationData,
  getOvertimeApproval,
  getOvertimeDeclarant
} from "../actions";

const initialState = {
  overtimeRegistration: [],
  overtimeSummary: [],
  overtimeRegistrationData: [],
  overtimeApproval: [],
  overtimeDeclarant: [],
};

const overtimeSlice = createSlice({
  name: "overtime",
  initialState,
  reducers: {},
  extraReducers: {
    [showOvertimeRegistration.fulfilled]: (state, action) => {
      state.overtimeRegistration = action.payload || [];
    },
    [showOvertimeSummary.fulfilled]: (state, action) => {
      state.overtimeSummary = action.payload || [];
    },
    [showOvertimeRegistrationData.fulfilled]: (state, action) => {
      state.overtimeRegistrationData = action.payload || [];
    },
    [getOvertimeApproval.fulfilled]: (state, action) => {
      state.overtimeApproval = action.payload || [];
    },

    
    [getOvertimeDeclarant.pending]: (state) => {
      state.loading = true;
    },
    [getOvertimeDeclarant.fulfilled]: (state, action) => {
      state.overtimeDeclarant = action.payload || [];
      state.loading = false;
    },
    [getOvertimeDeclarant.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export const responseOvertime = (state) => state.overtime;

export default overtimeSlice.reducer;
